import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TranslationService } from '@app/core/_base/layout';
import { environment } from '@app/env-service';

import { Staff, Assignee } from '../store/staff.model';

@Injectable({
  providedIn: 'root',
})
export class StaffService {
  url :string = environment.url;

  private readonly _staff = new BehaviorSubject<Staff[]>([]);
  public staff$ = this._staff.asObservable();

  private readonly _assignee = new BehaviorSubject<Staff[]>([]);
  public assignee$ = this._assignee.asObservable();

  private readonly _roles = new BehaviorSubject<any[]>([]);
  public roles$ = this._roles.asObservable();

  private readonly _loading = new BehaviorSubject<boolean>(false);
  loading$ = this._loading.asObservable();

  private readonly _crmAssignees = new BehaviorSubject<Staff[]>([]);
  public crmAssignees$ = this._crmAssignees.asObservable();

  constructor(
    private http :HttpClient,
    private translate :TranslateService,
    private translation :TranslationService,
  ) {
    this.getRecords();
    this.getRecordsAssignee();
    this._roles.next(this.getRoles());
    this.translate.onLangChange.subscribe((event :LangChangeEvent) => {
      this._roles.next(this.getRoles());
    });
  }

  getRoles() {
    return [
      { role_id: 2, role: this.translate.instant('ACCOUNT.MEMBER_SALES') },
      { role_id: 8, role: this.translate.instant('ACCOUNT.SUPPLIER_ADMIN') },
      { role_id: 1, role: this.translate.instant('ACCOUNT.MEMBER_STAFF') },
      { role_id: 88, role: 'Admin' },
      { role_id: 99, role: 'Super Admin' },
    ];
  }

  updateRecord(newRecord :Staff, id :number) :Observable<any> {
    return this.http.put(`${this.url}/users/${id}`, newRecord).pipe(
      tap((data :any) => {
        if (data.record) {
          const records = this._staff.getValue();
          const idx = records.findIndex((row) => {
            return row.id == id;
          });
          records.splice(idx, 1, <Staff>data.record);
          this._staff.next([...records]);
        }
      }),
    );
  }

  createRecord(data :Staff) :Observable<any> {
    return this.http.post(`${this.url}/users`, data).pipe(
      tap((data :any) => {
        if (data.record) {
          const staff :Staff = data.record as Staff;
          this._staff.next([staff, ...this._staff.getValue()]);
        }
      }),
    );
  }

  deleteRecord(id :number) :Observable<any> {
    return this.http.delete(`${this.url}/users/${id}`).pipe(
      tap((data :any) => {
        const records = this._staff.getValue();
        const idx = records.findIndex((row) => {
          return row.id == id;
        });
        records.splice(idx, 1);
        this._staff.next([...records]);
      }),
    );
  }

  getRecords() {
    this.http.get(`${this.url}/users`).subscribe((data :any) => {
      this._staff.next(<Staff[]>data.records);
    });
  }

  getRecordsAssignee() {
    this.http.get(`${this.url}/users/assignees`).subscribe((data :any) => {
      this._assignee.next(<Assignee[]>data.records);
    });
  }

  getAll() :Observable<any> {
    const params :any = { deleted: 1 };

    return this.http.get(`${this.url}/users`, { params: params });
  }

  getAllAssignee() :Observable<any> {
    const params :any = { deleted: 1 };

    return this.http.get(`${this.url}/users/assignees`, { params: params });
  }

  searchAssignee(keyword :string, roles :string = null) :Subscription {
    const params = {
      keyword: keyword,
      roles: roles,
    };
    this._loading.next(true);

    return this.http
      .get<any>(`${this.url}/users/assignees`, { params: params })
      .subscribe((resp) => {
        this._crmAssignees.next(resp.records);
        this._loading.next(false);

        return resp;
      });
  }

  transferAssignments(data :any) :Observable<any> {
    return this.http.post(`${this.url}/users/transfers`, data);
  }

  switchAssignments(data :any) :Observable<any> {
    return this.http.post(`${this.url}/users/switch`, data);
  }

  getStaffById(id :number) {
    // return this.staff$.filter((el: any) => el.id == id);
  }
}
